import { render } from "./ApiTokenManager.vue?vue&type=template&id=412b3084"
import script from "./ApiTokenManager.vue?vue&type=script&lang=js"
export * from "./ApiTokenManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__